var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1765_76136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 14.6663C4.81816 14.6663 1.8335 11.6817 1.8335 7.99967C1.8335 4.31767 4.81816 1.33301 8.50016 1.33301C12.1822 1.33301 15.1668 4.31767 15.1668 7.99967C15.1668 11.6817 12.1822 14.6663 8.50016 14.6663ZM8.50016 13.333C9.91465 13.333 11.2712 12.7711 12.2714 11.7709C13.2716 10.7707 13.8335 9.41416 13.8335 7.99967C13.8335 6.58519 13.2716 5.22863 12.2714 4.22844C11.2712 3.22824 9.91465 2.66634 8.50016 2.66634C7.08567 2.66634 5.72912 3.22824 4.72893 4.22844C3.72873 5.22863 3.16683 6.58519 3.16683 7.99967C3.16683 9.41416 3.72873 10.7707 4.72893 11.7709C5.72912 12.7711 7.08567 13.333 8.50016 13.333ZM8.50016 7.05701L10.3855 5.17101L11.3288 6.11434L9.44283 7.99967L11.3288 9.88501L10.3855 10.8283L8.50016 8.94234L6.61483 10.8283L5.6715 9.88501L7.5575 7.99967L5.6715 6.11434L6.61483 5.17101L8.50016 7.05701Z",
    fill: "#0A0903"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1765_76136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageclose);
export default __webpack_public_path__ + "static/media/imageclose.a553f34a.svg";
export { ForwardRef as ReactComponent };